import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GlobalSearchResult} from '../../shared/models/commons';
import {environment} from '../../environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private httpClient: HttpClient = inject(HttpClient)

  search(term: string): Observable<GlobalSearchResult[]> {
    return this.httpClient.get<GlobalSearchResult[]>(`${environment.baseUri}/global/search?term=${term}`);
  }
}
